var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a7 7 0 0 0-7 7v7.25l.005.2A3.75 3.75 0 0 0 8.75 20h1.128a2.251 2.251 0 1 0 0-1.5H8.75l-.154-.005A2.25 2.25 0 0 1 6.5 16.25V9a5.5 5.5 0 1 1 11 0v1l-.5 6a2 2 0 0 0 2-2V9a7 7 0 0 0-7-7Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16h2c.173 0 .34-.022.5-.063V10H15a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1ZM9 10H6.5v5.937c.16.041.327.063.5.063h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Z",
    fill: "#999"
  })));
};
export default SvgHelp;